/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:23
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"

export default class extends Controller {

    connect() {
      // console.log("-=> opportunity_controller connected");

      var opportunity_id = this.data.get("id");
      // console.log("-=> opportunity_controller connected (" + opportunity_id + ")");

      $('#change_status .dropdown')
        .dropdown({
          onChange: function(value, text, $selectedItem) {
            window.location.href = "/opportunities/" + opportunity_id + "/change_status/" + value;
          }

        })
      ;

      // Edit form
      $('.edit_opportunity')
      .form({
        on: 'blur',
        fields: {
          opportunity_name: {
            rules: [{ type : 'empty' }]
          },
          opportunity_contact_email: {
            rules: [{ type : 'email' }]
          },
          opportunity_url:  {
            optional   : true,
            rules: [{ type : 'url' }]
         }
        }
      })
    ;

    }

    initialize() {
    }

    rig_scratch_modal() {
      // console.log("-=> opportunity_controller rig_scratch_modal");
      var opportunity_id = this.data.get("id");
      $('.ui.modal')
        .modal({
          closable : false, 
          transition: 'fly left',
          onApprove : function(el) {
            console.log(el);
            $.post( '/opportunities/' + opportunity_id + '/save_scratchpad', { data: $('#scratchpad_body').val() } );
          }
        })
        .modal('show');
    }

  };

  // console.log("-=> opportunity_controller loaded");


